import { z } from "zod";

export const ProfileResponseSchema = z.object({
  id: z.string(),
  email: z.string(),
  githubUserId: z.number().nullable(),
  avatarUrl: z.string().nullable(),
  login: z.string().nullable(),
  role: z.string().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ProfileResponse = z.infer<typeof ProfileResponseSchema>;

export const LogoutResponseSchema = z.object({
  success: z.boolean(),
});

export type LogoutResponse = z.infer<typeof LogoutResponseSchema>;
